import MmenuLight from 'mmenu-light/esm/core/index';

// mmenu Light
// https://mmenujs.com/mmenu-light/docs.html
function MobileMenu(){
    
    const mobile_menu = document.getElementById( "responsive-menu" );

    if( mobile_menu ){
        const menu = new MmenuLight( mobile_menu, "(max-width: 900px)" );
        const navigator = menu.navigation({
            // slidingSubmenus: false,
            title: "Menu",
            theme: "dark"
        });

        const drawer = menu.offcanvas({
            position: "left"
        });
        
        document.querySelector( '.menu-toggle' ).addEventListener( 'click', function(e){
            e.preventDefault();
            drawer.open();
        });
    }
}

export { MobileMenu };
